import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { EditSuggestedCustomerPersonaPopup } from './EditSuggestedCustomerPersonaPopup';

export const EDIT_SUGGESTED_CUSTOMER_PERSONA_POPUP = Symbol('EDIT_SUGGESTED_CUSTOMER_PERSONA');

export const useEditSuggestedCustomerPersonaPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(EDIT_SUGGESTED_CUSTOMER_PERSONA_POPUP, EditSuggestedCustomerPersonaPopup);
  });

  return useCallback(
    (customerPersona = null, onSubmit = null, brandVoice) => {
      popups.openPopup(EDIT_SUGGESTED_CUSTOMER_PERSONA_POPUP, {
        customerPersona,
        brandVoice,
        onClose: () => {
          popups.closePopup(EDIT_SUGGESTED_CUSTOMER_PERSONA_POPUP);
        },
        onSubmit: async (data) => {
          await onSubmit(data);
          popups.closePopup(EDIT_SUGGESTED_CUSTOMER_PERSONA_POPUP);
        },
      });
    },
    [popups]
  );
};
